export const formatBRL = (value) =>
  Number(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const installmentText = (price, n = 3) =>
  `ou ${n}x de ${formatBRL(price / n)}`;

export const discountPercent = (oldPrice, price) =>
  Math.round(((oldPrice - price) / oldPrice) * 100);
